<template>
  <div class="detail">
    <div class="reject" v-if="(form.status == -1 || form.status == 3) && form.reject_reason && form.reject_reason != ''">
      <div class="reject-reason"><strong>作废（退回）原因:</strong></div>
      <div class="reject-reason">{{ form.reject_reason }}</div>
    </div>
      <van-field
        v-if="form.id && form.id != 0"
        v-model="form.id"
        :disabled="disabled"
        label="申请id"
        placeholder=""
      />
      <van-field
        v-if="form.pass_id && form.pass_id != 0"
        v-model="form.pass_id"
        :disabled="disabled"
        label="审核通过id"
        placeholder=""
      />
      <van-field
        v-model="form.name"
        :disabled="disabled"
        name="name"
        label="姓名"
        placeholder="需和银行账户的户名一致"
        :rules="[{ required: true, message: '请填写姓名（企业）' }]"
      />
      <van-field
        v-model="form.id_number"
        :disabled="disabled"
        name="id_number"
        label="身份证号"
        placeholder="身份证号"
        :rules="[{ required: true, message: '请填写证件号' }]"
      />
      <van-field
        v-model="form.telephone"
        :disabled="disabled"
        name="telephone"
        label="手机号"
        type="digit"
        placeholder="手机号"
        :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <van-field
        v-model="form.subdistrict"
        :disabled="disabled"
        name="subdistrict"
        label="街道"
        placeholder="手机号"
      />
      <van-field
        v-model="form.address"
        :disabled="disabled"
        name="address"
        label="房屋详细地址"
        placeholder="需和房产证中一致"
        :rules="[{ required: true, message: '请填写详细地址' }]"
      />
      <van-field
        v-model="form.invoice_amount"
        :disabled="disabled"
        name="invoice_amount"
        label="申报发票总金额/元"
        type="number"
        placeholder="请仔细核对发票统计金额"
        :rules="[{ required: true}]"
      />
      <van-field
        v-model="form.bank_name"
        :disabled="disabled"
        name="bank_name"
        label="补贴收款银行开户行"
        placeholder="补贴收款银行开户行"
        :rules="[{ required: true, message: '请填写补贴收款银行开户行' }]"
      />
      <van-field
        v-model="form.bank_card_no"
        name="bank_card_no"
        :disabled="disabled"
        label="补贴收款银行账户号"
        placeholder="补贴收款银行账户号"
        :rules="[{ required: true, message: '请填写补贴收款银行账户号' }]"
      />
      <van-field  name="photo_id_front" label="身份证（统一社会信用代码）照片（正面）" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
            <van-image v-for="(img,index) in form.photo_id_front.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_id_front,index)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field  name="photo_id_reverse" label="身份证照片（背面）" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
            <van-image v-for="(img,index) in form.photo_id_reverse.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_id_reverse,index)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field name="photo_notification" label="装修备案通知书" :disabled="disabled" >
        <template #input>
          <div class="upload-img">
            <div v-for="(img,index) in form.photo_notification.split(',')" :key="index">
              <van-image class="upload-icon" :src="img" @click="preview(form.photo_notification,index)">
              </van-image>
            </div>
          </div>
        </template>
      </van-field>
      <van-field name="photo_estate_license" label="房产证明照片" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
            <van-image v-for="(img,index) in form.photo_estate_license.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_estate_license,index)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-if="form.photo_contract.length > 0" name="photo_contract" label="非整包装修合同照片" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
            <van-image v-for="(img,index) in form.photo_contract.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_contract,index)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-if="form.pdf_contract.length > 0" name="pdf_contract" label="整包装修合同PDF" :disabled="disabled" :rules="[{ message: '请填上传pdf文件不超过15M' }]">
        <template #input>
          <van-image @click="openPDF(form.pdf_contract)" width="30px" src="//res.shaoxing.com.cn/a/10001/202409/3251e45a9ebcee53c98da68b80f3a0e4.png">
          </van-image>
          <p @click="openPDF(form.pdf_contract)">装修合同PDF</p>
        </template>
      </van-field>
      
      <van-field  name="photo_invoice" label="发票照片" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
            <van-image v-for="(img,index) in form.photo_invoice.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_invoice,index)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field name="photo_pay_record" label="支付凭证照片" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
              <van-image v-for="(img,index) in form.photo_pay_record.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_pay_record,index)">
              </van-image>
          </div>
        </template>
      </van-field>
      <van-field name="photo_commitment" label="购置补贴申请表" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
            <van-image v-for="(img,index) in form.photo_commitment.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_commitment,index)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-if="form.photo_renovation_before.length > 0" name="photo_renovation_before" label="材料进场照片(选填)" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
            <van-image v-for="(img,index) in form.photo_renovation_before.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_renovation_before,index)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field name="photo_renovation_current" label="施工前或施工中照片" :disabled="disabled" :rules="[{ required: true, message: '上传图片' }]">
        <template #input>
          <van-image v-for="(img,index) in form.photo_renovation_current.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_renovation_current,index)">
          </van-image>
        </template>
      </van-field>
      <van-field v-if="form.photo_renovation_after.length > 0" name="photo_renovation_after" label="装修完工照片(选填)" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
            <van-image v-for="(img,index) in form.photo_renovation_after.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_renovation_after,index)">
            </van-image>
          </div>
        </template>
      </van-field>
      <van-field v-if="form.photo_nameplate.length > 0" name="photo_nameplate" label="房屋竣工铭牌照片(选填)" :disabled="disabled" >
        <template #input>
          <div class="upload-img" >
            <van-image v-for="(img,index) in form.photo_nameplate.split(',')" :key="index" class="upload-icon" :src="img" @click="preview(form.photo_nameplate,index)">
            </van-image>
          </div>
        </template>
      </van-field>
  </div>
</template>
<script>
import axios from 'axios'
import { mc, util } from '../../assets/common2.js'
import { ImagePreview } from 'vant'
export default {
  name: 'HouseDetail',
  props: {
  },
  data () {
    return {
      form_id: null,
      loading: false,
      form: {},
      disabled: true,
      pdf_contract: []
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
    // CommentComponent
  },
  computed: {
  },
  created: function () {
    this.form_id = this.$route.params.form_id
    this.fid = this.$route.params.fid
  },
  mounted: function () {
    this.getDetail()
  },
  methods: {
    preview(img,index) {
      var images = img.split(',')
      ImagePreview({
        images,
        startPosition: index,
      })
    },
    getDetail() {
      util.Arequest((data) => {
        axios.post(`/encrypt3/form/detail?form_id=${this.form_id}&userid=${data.userid}&fid=${this.$store.state.fid}`,{token:data.token}).then(res => {
            if (res.data.msg == 'ok') {
              this.form = res.data.form
              this.pdf_contract = this.form.pdf_contract.split(',')
              this.loading = false;
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
            } else if (res.data.msg == 'not exists') {
              this.$toast('没有该申请')
            } else if (res.data.msg == 'error merchant') {
              this.$toast('非法请求')
            } else {
              this.$toast('网络繁忙\n稍后重试')
            } 
          }).catch(() => {
            this.$toast('网络繁忙\n稍后重试')
          })
      })
    },
    openPDF(pdf) {
      
      mc.linkOpen('http:'+pdf)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.reject {
  background-color: aqua;
  padding-top: 0.5rem;
}
.reject-reason {
  width: 90%;
  margin: auto;
  text-align: left;
  line-height: 1.4rem;
}
.upload-img {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.upload-icon {
  width: 28%;
  margin: 3px 3px;
}
</style>
